import React from 'react';
import { Carousel } from 'react-bootstrap';



const Slider = () => {


    return (
        /* Showing Curosole in the home page */
        <div className="">
            <Carousel>
                <Carousel.Item>
                    <img
                        className="w-100"
                        src="https://i.ibb.co/qsgHxvV/React-2-1200x300.jpg"
                        alt="React Js"
                    />
                    <Carousel.Caption>
                        <h3>React is not a framework, it’s a frontend library, but many developers consider it a framework and it’s usually compared in that context.</h3>

                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="w-100"
                        src="https://i.ibb.co/bWfzNDh/2.jpg"
                        alt="Express"

                    />

                    <Carousel.Caption>
                        <h3>Backbone is an extremely light front-end framework that’s fit for building rich Single-Page applications. It follows an MV* pattern and partly implements the MVC design.</h3>

                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="w-100"
                        src="https://i.ibb.co/743XX5h/expressjs-1-1200x300.png"
                        alt="Backbone"
                    />

                    <Carousel.Caption>
                        <h3>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</h3>


                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>

        </div>
    );
};

export default Slider;